import LoginSendCode from 'assets/images/auth/Group 393.svg'

interface Props {
    /** Replaces the «شماره موبایل خود را وارد نمایید» line. */
    subtitle?: string
}

const LoginHeader = ({ subtitle }: Props) => {
    return (
        <div className="mt-20">
            <img
                alt="login send code"
                src={LoginSendCode}
                className="block m-auto mb-10 w-107.05 h-89"
            />
            <p className="text-center mt-4 text-green-1 text-lg  mb-6 ">
                ثبت‌نام یا ورود
            </p>
            <p className=" text-center text-sm font-normal text-text-gray">
                {subtitle ??
                    'برای ثبت‌نام و یا ورود، شماره موبایل خود را وارد نمایید'}
            </p>
        </div>
    )
}

export default LoginHeader
